

<template>
  <img :src="topImg" style="height:auto;width: 100%;"/>
  <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
    <el-tab-pane label="公司简介" name="first" style="line-height: 30px;color: #656464;padding:0 10%">
      <div style="padding: 10px;border-top:1px solid #7D7D7D">
        <b style="color: #ff0000">企业理念</b>
        <div style="padding-left:50px">
          企业愿景：信 致 远<br>
          企业使命：利他人  创美好<br>
          核心价值观：高效协同 大道至简 行正共赢<br>
          经营宗旨：优商品 优服务 好便利<br><br>
          随时随地汇米巴！
        </div>
      </div>
      <div>
        <b style="color: #ff0000">公司简介</b>
        <div style="padding-left: 50px">
          湖南汇米巴商业管理有限公司成立于2011年8月，主营业务包括线下实体门店和线上销售业务两大板块，目前拥有汇米巴便利店、汇米生鲜店、IBBG B2B平台。<br>
          2013年，配备高标准的中央厨房，汇米巴便利店每天提供盒饭、寿司、卤菜、关东煮等鲜食产品，为消费者一日三餐健康、便利就餐提供有力保障。<br>
          2015年，汇米巴配备自动化拆零分拣系统，建立公交化物流体系，具备三温带配送能力，确保各类商品24小时保质保量送达。<br>
          2016年，汇米巴开放特许加盟模式，大规模发展紧密型加盟体系。<br>
          2018年，汇米巴引入内加盟模式和阿米巴激励模式，充分带动创业和就业，促进便利店又快又好地发展。<br>
          2019年，汇米巴开启“汇米生鲜”模式，“便利+生鲜”更大程度满足消费者健康、安全、幸福生活的需求。<br>
          2020年，”汇米到家”线上零售模式盛大起航，满足消费者便利购物需求。<br>
          汇米巴公司曾荣获CCFA“2018中国便利店创新奖”和“2019中国便利店创新奖”，被湖南省食品流通行业协会授予”湖南省诚信食品商AAAAA级单位”。在2020湖南省连锁零售高峰论坛上荣获“2020年度湖南十大影响力品牌”和“2020年度湖南最具投资价值品牌”。<br>
        </div>
      </div>
      <img src="../assets/image/5-21010G61003201.jpg" style="height:auto;width: 100%;"/>
      <div>
        <div>
          <b style="color: #ff0000">汇米巴便利店</b>
          <div style="padding-left: 50px">
            汇米巴以创造便利生活为经营宗旨，拥有强大的供应链能力，高效的仓配一体式物流能力，专业化和标准化的运营能力。以整洁明亮的店面形象、高品质的商品、温馨的服务赢得了广大加盟者与消费者的认同。
          </div>
        </div>
        <div>
          <b style="color: #ff0000">汇米生鲜</b>
          <div style="padding-left: 50px">
            是汇米巴旗下的生鲜便利店，经营定位为“家门口的菜市场”，经营品项包括蔬菜水果、粮油禽蛋、肉类水产、即食产品、厨房调料、酒水饮料、休闲冲调及日用百货。汇米生鲜经营品项丰富、产品安全健康、注重新鲜场景打造、提供贴心超值服务，能全方位满足消费者一日三餐所需，为消费者提供“方便、快捷、健康、安全”的一揽子生活解决方案。
          </div>
        </div>
        <div>
          <b style="color: #ff0000">IBBG</b>
          <div style="padding-left: 50px">
            主营B2B平台业务，为各中小型零售商提供优质特色的商品与供应链服务。iBBG平台服务于湖南各地市近10000余家便利零售终端，同时还为中小型零售商提供专业的陈列指导、店铺优化、培训支持等全面的营运支持服务。
            iBBG平台目前已发展为开放式线上平台，全国乃至全球各地的供应商可以直接入驻，真正为快消品牌和零售终端提供“一站式解决”的快捷便利服务。
          </div>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="发展历程" name="second">
      <div style="text-align: center">
        <img src="../assets/image/3-221116163626148.jpg" style="height:auto;width: 60%;"/>
      </div>
    </el-tab-pane>
    <el-tab-pane label="公司掠影" name="third">
        <el-row :gutter="20" style="justify-content: center;align-content: center">
          <el-col :lg="5" :md="12" :sm="12" :xs="24"  v-for="(item,index) in lista" :key="index" style="text-align: center;padding: 0" >
            <img :src="item.img" style="width: 80%;height: 80%" />
            <div style="text-align: center">{{item.name}}</div>
          </el-col>
        </el-row>
    </el-tab-pane>
  </el-tabs>
  <!--  <img alt="Vue logo" src="../assets/image/2-200422130615V2.jpg" style="height:auto;width: 100%;border-radius: 20px;">-->
</template>
<script>
export default {
  name: 'HelloWorld',
  // props: {
  //   msg: String
  // }
  data(){
    return{
      topImg:require('../assets/image/5-200FG140031M.jpg'),
      activeName:'first',
      list:[
        {  name:'公司简介',value:1 },
        {  name:'发展历程',value:2 },
        {  name:'公司掠影',value:3},
      ],
      lista:[
        {  name:'门店形象',img: require('../assets/image/aboutimg/1-1.jpg') },
        {  name:'公司环境',img: require('../assets/image/aboutimg/1-2.jpg') },
        {  name:'门店服务',img: require('../assets/image/aboutimg/1-3.jpg') },
        {  name:'汇米生鲜',img: require('../assets/image/aboutimg/1-4.jpg')},

      ]
    }
  },methods:{
    handleClick(e){
      console.log(e)
    }
  }
}
</script>

<style scoped>
:deep .el-tabs__item.is-active, .el-tabs__item:hover {
  color: #FF5000 !important;
}

:deep  .el-tabs__active-bar {
  background-color:white;

}
:deep .el-tabs__nav {
  float: unset;
  justify-content: center;
  display: flex;
  background: white;

}
.el-tabs__nav.is-top {
  background: white;

}
.el-tabs__content{
  height: 100%;
}
</style>